import React, {useContext, useState} from 'react'
import {Button, Table} from "antd";
import {OfferContext} from "../../../context/OfferContext";
import ReactDragListView from "react-drag-listview";
import StockCreate from "../../stok/StockCreate";
import OfferCreateTotalStockQuantity from "./OfferCreateTotalStockQuantity";
import OfferCreateStock from "./OfferCreateStock";
import OfferCreateQuantity from "./OfferCreateQuantity";
import OfferCreateInfo from "./OfferCreateInfo";
import OfferCreateUnit from "./OfferCreateUnit";
import OfferCreatePrice from "./OfferCreatePrice";
import OfferCreateCurrency from "./OfferCreateCurrency";
import OfferDiscount from "./OfferDiscount";
import OfferCreateDiscount2 from "./OfferCreateDiscount2";
import OfferCreateRowTotal from "./OfferCreateRowTotal";
import OfferTerm from "./OfferTerm";
import OfferCreateShippingDate from "./OfferCreateShippingDate";
import OfferGiftCheckbox from "./OfferGiftCheckbox";
import OfferCreateActions from "./OfferCreateActions";

const OfferCreateMaterial = () => {
    const {materialInformation, stocks} = useContext(OfferContext)
    const [materials, setMaterials] = materialInformation
    const [stockList, setStockList] = stocks
    const [isStockModalVisible, setIsStockModalVisible] = useState(false)

    const handleAddRow = () => {
        const date = new Date()
        const obj = {quantity: 1, key: date.getTime()}
        const mockContext  = [...materials, obj]
        setMaterials(mockContext)
    }

    const dragProps = {
        onDragEnd(fromIndex, toIndex) {
            const data = [...materials];
            const item = data.splice(fromIndex - 1, 1)[0];
            data.splice(toIndex - 1, 0, item);
            setMaterials(data)
        },
        handleSelector: "a",
    };

    const updateStockContext = ({stockData, inventoryData}) => {
        let inventoryText = ''
        inventoryData.map((stock) => {
            inventoryText = inventoryText + `${stock.warehouse.name} - ${stock.quantity}`
        })

        const stockItem = {
            text: `${stockData.code} - ${stockData.name} ( ${inventoryText} )`,
            value: stockData.id
        }
        setStockList([...stockList, stockItem])
    }
    const toggleStockModal = () => setIsStockModalVisible(!isStockModalVisible)
    const columns = [
        {
            title: '#',
            key: 'rowID',
            render: (t, r, i) => <OfferCreateInfo record={r} rowCount={i + 1} />
        },
        {
            title: 'Top. Adet',
            key: 'totalQuantity',
            render: (t, r, i) => <OfferCreateTotalStockQuantity record={r} />
        },
        {
            title: 'Stok Adı',
            key: 'stockName',
            render: (t, r, i) => <OfferCreateStock rowIndex={i} record={r} />
        },
        {
            title: 'Miktar',
            key: 'quantity',
            render: (t, r, i) => <OfferCreateQuantity rowIndex={i} record={r}/>
        },
        {
            title: 'Birim',
            key: 'unit',
            render: (t, r, i) => <OfferCreateUnit record={r} />
        },
        {
            title: 'Birim Fiyatı',
            key: 'price',
            render: (t, r, i) => <OfferCreatePrice rowIndex={i} record={r} />
        },
        {
            title: 'Para Birimi',
            key: 'priceUnit',
            render: (t, r, i) => <OfferCreateCurrency rowIndex={i} record={r} />
        },
        {
            title: 'İskonto %',
            key: 'discount',
            render: (t, r, i) => <OfferDiscount rowIndex={i} record={r} />
        },
        {
            title: 'İskonto 2',
            key: 'discount 2',
            render: (t, r, i) => <OfferCreateDiscount2 rowIndex={i} record={r} />
        },
        {
            title: 'Toplam',
            key: 'rowTotal',
            render: (t, r, i) => <OfferCreateRowTotal record={r} />
        },
        {
            title: 'Termin Tarihi',
            key: 'deadline',
            render: (t, r, i) => <OfferTerm rowIndex={i} record={r} />
        },
        {
            title: 'Sevk Tarihi',
            key: 'shippingDeadline',
            render: (t, r, i) => <OfferCreateShippingDate rowIndex={i} record={r} />
        },
        {
            title: 'Hediye',
            key: 'shippingDeadline',
            render: (t, r, i) => <OfferGiftCheckbox rowIndex={i} record={r} />
        },
        {
            title: 'İşlemler',
            key: 'actions',
            render: (t, r, i) => <OfferCreateActions rowIndex={i} record={r} />
        }
    ]

    return(
        <React.Fragment>
            <Button
                style={{marginBottom: '16px'}}
                type={'link'}
                onClick={() => handleAddRow()}
            >
                Yeni Kalem Ekle
            </Button>
            <Button
                style={{marginBottom: '16px'}}
                type={'link'}
                onClick={toggleStockModal}
            >
                Yeni Stok Ekle
            </Button>
            <ReactDragListView onDragEnd={dragProps.onDragEnd}>
                <Table dataSource={materials} columns={columns} scroll={{x: 'max-content'}} pagination={false}/>
            </ReactDragListView>
            {
                isStockModalVisible
                    ? <StockCreate show={isStockModalVisible}
                                   modalCloser={toggleStockModal}
                                   updater={updateStockContext}
                                    bubbleResponse={true}
                    />
                    : null
            }
        </React.Fragment>
    )
}
export default OfferCreateMaterial